import apis from '@/apis'
import EventBus from '@/controllers/EventBus'

// URL and endpoint constants
const BASE_API = 'https://lasting-impressions.com.my/october/'
// const BASE_API = `${location.protocol}//lasting-impressions.com.my/october/`
const PATH_LOGIN = 'authapi/login'
// const PATH_LOGOUT = 'authapi/logout'
const PATH_REGISTER = 'authapi/register'
const PATH_VERIFY = 'users/verify'
const PATH_USERS = 'users'
const PATH_PROJECTS = 'projects'
const PATH_INSTAGRAM_TAGPAGE = 'api/instagram/tagpage'
const PATH_INSTAGRAM_USERPAGE = 'api/instagram/userpage'

export default {

  login (creds) {
    return new Promise((resolve, reject) => {
      apis.post(PATH_LOGIN, creds)
      .then(data => {
        EventBus.$emit('authenticated', data)
        resolve(data)
      })
      .catch(error => {
        EventBus.$emit('unauthenticated')
        reject(error)
      })
    })
  },

  register (creds) {
    return new Promise((resolve, reject) => {
      apis.post(PATH_REGISTER, creds)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  logout (context, callback) {
    EventBus.$emit('unauthenticated')
    callback(context)
  },

  verify (token) {
    return new Promise((resolve, reject) => {
      apis.get(PATH_VERIFY + '/' + token, {})
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  users () {
    return new Promise((resolve, reject) => {
      apis.get(PATH_USERS)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  projects () {
    return new Promise((resolve, reject) => {
      apis.get(PATH_PROJECTS)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  instagramUser (token, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.get(PATH_INSTAGRAM_USERPAGE + '/' + token + maxidString)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  instagramTag (tag, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.get(PATH_INSTAGRAM_TAGPAGE + '/' + tag + '/24' + maxidString)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  instagramApi (limit = 20, offset = 0) {
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.get(`api/instagram2/medias/${limit}/${offset}`)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  about () {
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.get('about')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  company () {
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.get('company')
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  carousel () {
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.get('carousel')
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  email (name, email, phone, message) {
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.post('email', { name: name, email: email, phone: phone, message: message })
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  gallery () {
    return new Promise((resolve, reject) => {
      apis.baseUrl = BASE_API
      apis.get('gallery')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/Auth.js